import { render, staticRenderFns } from "./refs_list.vue?vue&type=template&id=8de7d668"
import script from "./refs_list.vue?vue&type=script&lang=js"
export * from "./refs_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports